import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteJustification = api(function deleteJustification(auditId) {
    return mutate(
        gql`
            mutation DeleteJustification($auditId: String!) {
                deleteJustification(auditId: $auditId)
            }
        `,
        { auditId },
        { returns: "deleteJustification" }
    )
})
